export const moneyToStr = (value: number): string => {
  if (value >= 10 ** 9) return Math.round(value / 10 ** 7) / 100 + 'B';
  if (value >= 10 ** 6) return Math.round(value / 10 ** 4) / 100 + 'M';
  return value.toLocaleString() + '.00';
};

export const moneyToNum = (value: string): number => {
  if (value.includes('B')) return +value.replace('$', '').split('B')[0] * 10 ** 9;
  if (value.includes('M')) return +value.replace('$', '').split('M')[0] * 10 ** 6;
  const strToNum = value.split('.')[0].match(/\d/g)?.join('') || 0;
  return +strToNum;
};

export const capitalize = (str: string): string => {
  return str && str.replace(str[0], str[0].toUpperCase());
};

export const getDate = (date: string | number | undefined, withTime = false) => {
  const newDate = date ? new Date(date) : new Date();
  const normalize = (val: string) => (val.length > 1 ? val : `0${val}`);
  return (
    `${normalize(`${newDate.getDate()}`)}.${normalize(`${newDate.getMonth() + 1}`)}.${newDate.getFullYear()}` +
    (withTime
      ? ` ${[`${newDate.getHours()}`, `${newDate.getMinutes()}`, `${newDate.getSeconds()}`].map(normalize).join(':')}`
      : '')
  );
};

export function formatToStringTime(timestamp: number): string {
  const date = new Date(timestamp * 1000);
  return date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
}

export const getDateOffset = (date: Date | null) => {
  return date ? new Date(+date + -1 * (date as Date).getTimezoneOffset() * 1000 * 60).toISOString() : null;
};

export const sanitizeDate = (date?: Date | null): Date | undefined =>
  date instanceof Date && !isNaN(date.getTime()) ? date : undefined;

export const getExternalUrl = (url: string): string => {
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  else return `http://${url}`;
};

export const strToAnchor = (str: string): string => {
  return str.replace(/[\s]/g, '_');
};

export const strToUrl = (str: string): string => str.replace(/[\s]/g, '-').toLowerCase();

export const strToBase64 = (str: string /*replace = false*/): string => {
  try {
    // const encode = btoa(str);
    const utf8Bytes = new TextEncoder().encode(str);
    const encode = btoa(String.fromCharCode(...Array.from(utf8Bytes)));
    return encode;
    // return replace ? encode.replace(/['+']/g, '-').replace(/['/']/g, '_') : encode;
  } catch (e) {
    console.warn(e);
  }
  return '';
};

export const strFromBase64 = (str: string) => {
  // return atob(str);
  const binary = atob(str);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

export const updateImageUrl = (url: string, width: number, height?: number) => {
  return `${url}?tr=w-${width},h-${height || width},c-at_max`;
};
